import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="pt-20 pb-10 border-t transition-colors duration-300" style={{
    backgroundColor: 'var(--bg-primary)',
    color: 'var(--text-primary)',
    borderColor: 'var(--border-color)'
  }} data-id="element-90">
      <div className="container mx-auto px-6 md:px-12" data-id="element-91">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-92">
          <div className="col-span-1 md:col-span-2" data-id="element-93">
            <div className="flex items-center gap-2 mb-6" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/eu7Fkf1LNP9nCJy7uYGBCL/image.png" alt="Junquito Gas Logo" className="h-16 object-contain mix-blend-multiply dark:mix-blend-normal dark:brightness-125" style={{
              background: 'transparent'
            }} data-id="element-95" />
            </div>
            <p className="max-w-md mb-8 transition-colors duration-300" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-96">
              Distribuidora de combustibles (GLP, Gasoil y Gasolina) y
              estaciones de servicio comprometidas con ofrecer productos de la
              más alta calidad. Nuestra gasolina es distribuida en colaboración
              con NEXT. Combustible confiable y seguro para sus vehículos,
              hogares y negocios.
            </p>
            <div className="flex gap-4" data-id="element-97">
              <a href="https://www.facebook.com/junquitogas/?locale=es_LA" target="_blank" rel="noopener noreferrer" className="text-sm font-bold uppercase tracking-wider hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-muted)'
            }} data-id="element-98">
                Facebook
              </a>
              <a href="https://www.instagram.com/junquitogas/" target="_blank" rel="noopener noreferrer" className="text-sm font-bold uppercase tracking-wider hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-muted)'
            }} data-id="element-99">
                Instagram
              </a>
              <a href="https://wa.me/18092472104" target="_blank" rel="noopener noreferrer" className="text-sm font-bold uppercase tracking-wider hover:text-[#FCEE02] transition-colors" style={{
              color: 'var(--text-muted)'
            }} data-id="element-100">
                WhatsApp
              </a>
            </div>
          </div>

          <div data-id="element-101">
            <h4 className="font-bold uppercase tracking-wider mb-6" style={{
            color: 'var(--accent-yellow-text)'
          }} data-id="element-102">
              Servicios
            </h4>
            <ul className="space-y-4 transition-colors duration-300" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-103">
              {['GLP de Alta Calidad', 'Gasolina (NEXT)', 'Gasoil Premium', 'Estaciones Certificadas'].map(item => <li key={item} data-id="element-104">
                  <a href="#" className="hover:text-[#FCEE02] transition-colors flex items-center gap-2" data-id="element-105">
                    <span className="w-1 h-1 bg-[#EC2424]" data-id="element-106" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-107">
            <h4 className="font-bold uppercase tracking-wider mb-6" style={{
            color: 'var(--accent-yellow-text)'
          }} data-id="element-108">
              Contacto
            </h4>
            <ul className="space-y-4 transition-colors duration-300" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-109">
              <li className="flex items-center gap-2" data-id="element-110">
                <Phone className="w-4 h-4 text-[#FCEE02]" data-id="element-111" />
                +1-809-247-2104
              </li>
              <li className="flex items-center gap-2" data-id="element-112">
                <Mail className="w-4 h-4 text-[#FCEE02]" data-id="element-113" />
                info@junquitogas.com
              </li>
              <li className="flex items-start gap-2" data-id="element-114">
                <MapPin className="w-4 h-4 text-[#FCEE02] mt-1" data-id="element-115" />
                <span data-id="element-116">
                  Av. Presidente Antonio Guzmán Fernández
                  <br data-id="element-117" />
                  Santiago De Los Caballeros, RD
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm transition-colors duration-300" style={{
        borderColor: 'var(--border-color)',
        color: 'var(--text-muted)'
      }} data-id="element-118">
          <p data-id="element-119">&copy; 2026 Junquito Gas. Todos los derechos reservados.</p>
          <div className="flex gap-8" data-id="element-120">
            <a href="#" className="hover:text-[#FCEE02] transition-colors" data-id="element-121">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-[#FCEE02] transition-colors" data-id="element-122">
              Términos de Servicio
            </a>
          </div>
        </div>
      </div>
    </footer>;
}